interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export default function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-100 mb-4">
        <i className={`${icon} text-2xl text-foreground-300`}></i>
      </span>
      <h3 className="text-sm font-semibold text-foreground-600 mb-1 font-heading">{title}</h3>
      <p className="text-xs text-foreground-400 leading-relaxed max-w-[240px]">{description}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="mt-4 text-xs font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}